export default function BankIcon() {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      width="58"
      height="62"
      viewBox="0 0 58 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.2"
        d="M50.7967 27.81C54.966 26.94 57.9956 23.22 57.9956 18.95C57.9956 15.61 56.1658 12.56 53.2263 10.98L36.0689 1.78C33.8992 0.620001 31.4596 0 29 0C26.5404 0 24.1008 0.610001 21.9311 1.78L4.77372 10.98C1.83417 12.56 0.00444659 15.61 0.00444659 18.95C0.00444659 23.21 3.03398 26.94 7.20334 27.81L8.00322 27.98V41.18L7.53329 41.47C6.02352 42.41 4.80371 43.76 3.99383 45.37L0.744333 51.87C-0.3455 54.06 -0.235517 56.6 1.05428 58.68C2.33409 60.76 4.56375 62 7.00337 62H50.9966C53.4363 62 55.6659 60.76 56.9457 58.68C58.2355 56.6 58.3455 54.05 57.2557 51.87L54.0062 45.37C53.2063 43.76 51.9765 42.41 50.4667 41.47L49.9968 41.18V27.98L50.7967 27.81ZM51.8965 54.55C52.2264 55.21 51.7465 56 51.0066 56H7.00337C6.26349 56 5.77356 55.22 6.11351 54.55L9.36301 48.05C9.99292 46.79 11.2727 46 12.6825 46H45.3275C46.7273 46 48.0171 46.79 48.637 48.05L51.8865 54.55H51.8965ZM14.0123 40V28H26.0105V40H14.0123ZM32.0095 40V28H44.0077V40H32.0095ZM48.9569 22H9.05306C7.37332 22 6.00353 20.63 6.00353 18.95C6.00353 17.83 6.62343 16.8 7.61328 16.26L24.7706 7.06C27.3703 5.67 30.6497 5.67 33.2393 7.06L50.3967 16.26C51.3866 16.79 52.0065 17.82 52.0065 18.95C52.0065 20.63 50.6367 22 48.9569 22Z"
        fill="white"
      />
    </svg>
  );
}
